<template>
  <v-container>
    <v-card>
      <v-card-title> Reports </v-card-title>
      <v-card-text>
        {{ error }}
        <v-data-table
          :items="allReports"
          :headers="headerArray"
          :items-per-page="30"
          dense
        >
          <template v-slot:item.typeid="{ item }">
            {{ $store.getters.lookup("ReportType", item.typeid) }}
          </template>
          <template v-slot:item.="{ item }">
            <v-btn @click="maybeExecuteReport(item)">
              <v-icon>mdi-play</v-icon>
            </v-btn>
            <!-- <json-excel
          v-if="reportResult[item.id]"
          :data="reportResult[item.id]"
          type="csv"
        >
          <v-btn>Download</v-btn>
        </json-excel> -->
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog modal v-model="displayDialog" width="350px">
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Run Report "{{ report.name }}"</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <br />
          <v-form @submit.prevent="executeReport">
            <v-alert v-if="reportError[report.id]" type="error">
              {{ reportError[report.id] }}
            </v-alert>
            <template v-for="(param, index) in report.params">
              <div :key="`param-${index}`">
                <v-text-field
                  :label="param.screenprompt"
                  @input="$set(reportParams, param.paramname, $event)"
                  v-if="param.controltype === 'TextBox'"
                ></v-text-field>
                <v-menu
                  v-if="param.controltype === 'DatePickerStart'"
                  v-model="menu1"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="dateStart"
                      clearable
                      label="Start date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="dateStart = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateStart"
                    @change="menu1 = false"
                    @input="$set(reportParams, param.paramname, dateStart)"
                  ></v-date-picker>
                </v-menu>
                <v-menu
                  v-if="param.controltype === 'DatePickerEnd'"
                  v-model="menu2"
                  :close-on-content-click="false"
                  max-width="290"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="dateEnd"
                      clearable
                      label="End date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="dateEnd = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateEnd"
                    @change="menu2 = false"
                    @input="$set(reportParams, param.paramname, dateEnd)"
                  ></v-date-picker>
                </v-menu>
                <v-autocomplete
                  :label="param.screenprompt"
                  @input="$set(reportParams, param.paramname, $event)"
                  v-if="param.controltype === 'ComboBox'"
                  :items="param.options"
                  item-text="label"
                  item-value="value"
                  auto-select-first
                ></v-autocomplete>
              </div>
            </template>

            <v-btn primary type="submit" :loading="running"
              ><v-icon>mdi-play</v-icon> Run</v-btn
            >

            <json-excel
              v-if="reportResult[report.id]"
              :data="reportResult[report.id]"
              type="csv"
              :name="`${report.name}.csv`"
            >
              <v-btn><v-icon>mdi-download</v-icon>Download Now</v-btn>
            </json-excel>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import JsonExcel from "vue-json-excel";
export default {
  name: "AdminReportsPage",
  components: {
    JsonExcel,
  },
  data() {
    return {
      menu1: false,
      menu2: false,
      dateStart: "",
      dateEnd: "",
      allReports: [],
      loading: false,
      error: "",
      headerArray: [
        { text: "ID", value: "id" },
        { text: "name", value: "name" },
        { text: "description", value: "description" },
        { text: "Report Type", value: "typeid" },
        { text: "Action", value: "" },
      ],
      displayDialog: false,
      report: {},
      reportParams: {},
      reportResult: {},
      running: false,
      reportError: {},
    };
  },
  async created() {
    this.loading = true;
    try {
      const { data } = await this.$http.get("/reports");
      this.allReports = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].displayinreportlist === true) {
          this.allReports.push(data[i]);
        }
      }
    } catch (e) {
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  },
  methods: {
    async maybeExecuteReport(report) {
      try {
        this.report = { ...report };
        // const params = report.params;
        // if (params) {
        this.displayDialog = true;
        // } else {
        //   this.executeReport(report);
        // }
      } catch (e) {
        this.error = e.message;
      } finally {
        console.log(report);
      }
    },
    async executeReport() {
      try {
        this.running = true;
        const result = await this.$http.post(`reports/${this.report.id}/run`, {
          params: this.reportParams,
        });
        this.$set(this.reportResult, this.report.id, result.data);
      } catch (e) {
        console.error(e);
        this.reportError[this.report.id] = e.message;
      } finally {
        this.running = false;
      }
    },
  },
};
</script>
